// extracted by mini-css-extract-plugin
module.exports = {"spinContainer":"loader_spinContainer__3ISjZ","spin":"loader_spin__NN2t0"};